import { render, staticRenderFns } from "./DeliveryMethod.vue?vue&type=template&id=91773fb6&scoped=true"
import script from "./DeliveryMethod.vue?vue&type=script&lang=js"
export * from "./DeliveryMethod.vue?vue&type=script&lang=js"
import style0 from "./DeliveryMethod.vue?vue&type=style&index=0&id=91773fb6&prod&scoped=true&lang=css"
import style1 from "./DeliveryMethod.vue?vue&type=style&index=1&id=91773fb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91773fb6",
  null
  
)

export default component.exports